import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-access-denied',
  templateUrl: './access-denied.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./access-denied.component.scss'],
})
export class AccessDeniedComponent {}
